import { Form, FormProps, Select, SelectProps } from "antd";
import { useEffect, useState } from "react";
import api from "../../../common/api";
import { useTranslation } from "react-i18next";
import { DefaultOptionType } from "antd/es/select";

interface IDocumentsSelect {
  label?: string;
  placeholder?: string;
  form?: FormProps["form"];
  name?: string;
  onSelect?: (
    value: any,
    option: DefaultOptionType | DefaultOptionType[]
  ) => void;
  multiple?: boolean;
  value?: any;
  disabled?: boolean;
  [key: string]: unknown;
}

const DocumentsSelect = ({
  label,
  placeholder = "Hujjatni tanlang",
  form,
  name,
  onSelect,
  multiple = false,
  value,
  disabled = false,
  ...props
}: IDocumentsSelect) => {
  const [options, setOptions] = useState<SelectProps["options"]>([]);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const handleChange = (
    value: string[],
    option: DefaultOptionType | DefaultOptionType[]
  ) => {
    if (form && name) form?.setFieldValue(name, value || undefined);
    if (onSelect) onSelect(value || undefined, option);
  };

  const documentsGetAll = async () => {
    try {
      setLoading(true);
      const response = await api.document.getChoose({ page: 1, limit: 100 });
      setOptions(
        response.data.data.map((document) => ({
          label: document.name[i18n.language as "uz" | "ru" | "en"],
          value: document._id,
        }))
      );
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    documentsGetAll();
  }, []);

  return (
    <Form.Item name={name} label={label} style={{ margin: 0 }} {...props}>
      <Select
        mode={multiple ? "multiple" : undefined}
        allowClear
        style={{ minWidth: "200px" }}
        placeholder={placeholder}
        onChange={handleChange}
        options={options}
        loading={loading}
        value={value}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default DocumentsSelect;
